module.exports = __webpack_public_path__ + "static/media/C_F03.b8dd0bef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/C_F03.png
// module id = 74
// module chunks = 0